module.exports = __webpack_public_path__ + "assets/18138b3b229d0f142ac204b71b0b1a00.mp3";